import { Box, Divider, Paper, Skeleton } from '@mui/material';

const FieldWrapperSkeleton = () => (
  <Box display="flex" flexDirection="column" gap={1} minWidth={250}>
    <Skeleton variant="text" width={120} height={20} />
    <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
  </Box>
);

const LanguageEditorSkeleton = () => (
  <Box marginBottom={3}>
    <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
      <Skeleton variant="rectangular" width={20} height={15} />
      <Skeleton variant="rectangular" width={120} height={32} sx={{ borderRadius: 1 }} />
    </Box>
    <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: 1 }} />
  </Box>
);

const MultiLanguageInstructionsEditorSkeleton = () => (
  <Box>
    {[1, 2, 3].map((index) => (
      <LanguageEditorSkeleton key={index} />
    ))}
  </Box>
);

const CheckInOutSectionSkeleton = () => (
  <Box display="flex" flexDirection="column" gap={5}>
    <Skeleton variant="text" width={150} height={32} />
    
    <Box display="flex" gap={4}>
      <FieldWrapperSkeleton />
      <FieldWrapperSkeleton />
      <FieldWrapperSkeleton />
    </Box>

    <Box display="flex" flexDirection="column" gap={2}>
      <Skeleton variant="text" width={200} height={20} />
      <MultiLanguageInstructionsEditorSkeleton />
    </Box>
  </Box>
);

export const HotelCheckinCheckoutLoader = () => {
  return (
    <Paper elevation={0} sx={{ maxWidth: 1082 }}>
      <Box
        borderRadius={2}
        p={2}
        display="flex"
        flexDirection="column"
        gap={5}
      >
        {/* Check-in Section */}
        <CheckInOutSectionSkeleton />
        
        <Divider />
        
        {/* Check-out Section */}
        <CheckInOutSectionSkeleton />
      </Box>
    </Paper>
  );
};
